import { InMemoryCache } from '@apollo/client/core'

import type { RoleNameEnum } from '@/gql/myomr'

// Uncomment for debugging in dev mode:
// import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
// loadDevMessages();
// loadErrorMessages();

const cache = new InMemoryCache({
  possibleTypes: {
    Facet: [
      'CompanyCountryFacet',
      'CompanyDepartmentFacet',
      'CompanyFieldFacet',
      'CompanyIndustryFacet',
      'CompanyJobLevelFacet',
      'CompanySizeFacet',
      'CompanyTypeFacet',
      'CountryFacet',
      'NetworkingInterestFacet',
      'UserInterestFacet',
    ],
  },
  typePolicies: {
    Query: {
      fields: {
        // `ManageQuery` has no id, so every Manage query writes the same ROOT_QUERY.manage
        // object. The default behaviour replaces it, which drops the fields the other Manage
        // queries cached — a shallow merge keeps them, so revisited views read from the cache.
        manage: {
          merge: true,
        },
      },
    },
    Booth: {
      fields: {
        booths: {
          keyArgs: ['eventPeriod', 'type'], // separate cache key for each eventPeriod and type combination
        },
      },
    },
    User: {
      fields: {
        roles: {
          merge(_existing: RoleNameEnum[] = [], incoming: RoleNameEnum[]) {
            return incoming
          },
        },
      },
    },
    PartnerCompany: {
      fields: {
        interests: {
          merge(_existing: string[] = [], incoming: string[]) {
            return incoming
          },
        },
      },
    },
    UserPropertiesPreferences: {
      merge: true,
    },
  },
})

export default cache
